export default "__VITE_ASSET__1f8d0c82__"